// extracted by mini-css-extract-plugin
module.exports = {"btnSubmit":"TermsOfUse_btnSubmit__2RN3_","radioContainer":"TermsOfUse_radioContainer__2koNM"};